export const useRoutesList = () => {
    const routes = [
        { id: "10547007", text: "Auricular" },
        { id: "54471007", text: "Buccal" },
        { id: "448598008", text: "Cutaneous" },
        { id: "372449004", text: "Dental" },
        { id: "372450004", text: "Endocervical" },
        { id: "372451000", text: "Endosinusial" },
        { id: "372452007", text: "Endotracheopulmonary" },
        { id: "404820008", text: "Epidural" },
        { id: "18246711000001107", text: "Epilesional" },
        { id: "372453002", text: "Extraamniotic" },
        { id: "372454008", text: "Gastroenteral" },
        { id: "372457001", text: "Gingival" },
        { id: "9191401000001100", text: "Haemodiafiltration" },
        { id: "18682911000001103", text: "Haemodialysis" },
        { id: "10334211000001103", text: "Haemofiltration" },
        { id: "42260111000001107", text: "Implantation" },
        { id: "718329006", text: "Infiltration" },
        { id: "18679011000001101", text: "Inhalation" },
        { id: "372458006", text: "Intraamniotic" },
        { id: "58100008", text: "Intraarterial" },
        { id: "12130007", text: "Intraarticular" },
        { id: "372459003", text: "Intrabursal" },
        { id: "418821007", text: "Intracameral" },
        { id: "372460008", text: "Intracardiac" },
        { id: "372461007", text: "Intracavernous" },
        { id: "420719007", text: "Intracerebroventricular" },
        { id: "372462000", text: "Intracervical" },
        { id: "58761000052107", text: "Intracholangiopancreatic" },
        { id: "372463005", text: "Intracoronary" },
        { id: "372464004", text: "Intradermal" },
        { id: "876824003", text: "Intradialytic" },
        { id: "372465003", text: "Intradiscal" },
        { id: "448077001", text: "Intraepidermal" },
        { id: "58751000052109", text: "Intraglandular" },
        { id: "372466002", text: "Intralesional" },
        { id: "372467006", text: "Intralymphatic" },
        { id: "78421000", text: "Intramuscular" },
        { id: "372468001", text: "Intraocular" },
        { id: "417255000", text: "Intraosseous" },
        { id: "38239002", text: "Intraperitoneal" },
        { id: "372469009", text: "Intrapleural" },
        { id: "41489711000001101", text: "Intraputaminal" },
        { id: "372470005", text: "Intrasternal" },
        { id: "72607000", text: "Intrathecal" },
        { id: "447122006", text: "Intratumoral" },
        { id: "62226000", text: "Intrauterine" },
        { id: "47625008", text: "Intravenous" },
        { id: "372471009", text: "Intravesical" },
        { id: "418401004", text: "Intravitreal" },
        { id: "21856811000001103", text: "Iontophoresis" },
        { id: "46713006", text: "Nasal" },
        { id: "372472002", text: "Ocular" },
        { id: "26643006", text: "Oral" },
        { id: "372473007", text: "Oromucosal" },
        { id: "9191501000001101", text: "Percutaneous" },
        { id: "372474001", text: "Periarticular" },
        { id: "418722009", text: "Peribulbar" },
        { id: "372475000", text: "Perineural" },
        { id: "11478901000001102", text: "Periosseous" },
        { id: "58811000052103", text: "Peritumoral" },
        { id: "37161004", text: "Rectal" },
        { id: "372476004", text: "Subconjunctival" },
        { id: "34206005", text: "Subcutaneous" },
        { id: "66621000052103", text: "Sublabial" },
        { id: "37839007", text: "Sublingual" },
        { id: "419874009", text: "Submucosal" },
        { id: "58831000052108", text: "Subretinal" },
        { id: "6064005", text: "Topical" },
        { id: "45890007", text: "Transdermal" },
        { id: "11479001000001107", text: "Translingual" },
        { id: "404815008", text: "Transmucosal" },
        { id: "90028008", text: "Urethral" },
        { id: "16857009", text: "Vaginal" }
    ]

    return { routes }
}